/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/* Template custom: api */

import {
  ApiDocumentCertificateResponse,
  ApiDocumentCertificateVerifyResponse,
  ApiDocumentMetadataDto,
  ApiVerifyDocumentCertificateDto,
  ApiVerifyVideoCertificateDto,
  ApiVideoCertificateResponse,
  ApiVideoCertificateVerifyResponse,
  ApiVideoMetadataDto,
} from "./data-contracts";
import {
  ApiBaseError,
  ContentType,
  HttpClient,
  RequestParams,
} from "./http-client";

export class GtwCertificate<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Document Certificates
   * @name DocumentCertificateControllerSignDocument
   * @summary Generate signed authenticity certificate
   * @request POST:/gtw/certificate/documents/sign
   * @secure
   * @response `200` `ApiDocumentCertificateResponse` Returns signed authenticity certificate with digital signature
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  documentCertificateControllerSignDocument = (
    data: ApiDocumentMetadataDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiDocumentCertificateResponse, ApiBaseError>({
      path: `/gtw/certificate/documents/sign`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Document Certificates
   * @name DocumentCertificateControllerVerifyDocument
   * @summary Verify document certificate authenticity
   * @request POST:/gtw/certificate/documents/verify
   * @secure
   * @response `200` `ApiDocumentCertificateVerifyResponse` Returns true if certificate is valid
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Invalid certificate signature
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `404` `void` Certificate not found
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  documentCertificateControllerVerifyDocument = (
    data: ApiVerifyDocumentCertificateDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiDocumentCertificateVerifyResponse, ApiBaseError>({
      path: `/gtw/certificate/documents/verify`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Document Certificates
   * @name DocumentCertificateControllerVerifyDocumentFromFile
   * @summary Verify document certificate authenticity from file
   * @request POST:/gtw/certificate/documents/verify/file
   * @secure
   * @response `200` `ApiDocumentCertificateVerifyResponse` Returns true if certificate is valid
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Invalid certificate signature
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  documentCertificateControllerVerifyDocumentFromFile = (
    params: RequestParams = {},
  ) =>
    this.request<ApiDocumentCertificateVerifyResponse, ApiBaseError>({
      path: `/gtw/certificate/documents/verify/file`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Document Certificates
   * @name DocumentCertificateControllerGetAllDocumentsByWillId
   * @summary Get all document certificates by will ID
   * @request GET:/gtw/certificate/documents/wills/{willId}
   * @secure
   * @response `200` `(ApiDocumentCertificateResponse)[]` Returns array of document certificates
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  documentCertificateControllerGetAllDocumentsByWillId = (
    willId: string,
    params: RequestParams = {},
  ) =>
    this.request<ApiDocumentCertificateResponse[], ApiBaseError>({
      path: `/gtw/certificate/documents/wills/${willId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Document Certificates
   * @name DocumentCertificateControllerGetDocumentById
   * @summary Get document certificate by ID
   * @request GET:/gtw/certificate/documents/{id}
   * @secure
   * @response `200` `ApiDocumentCertificateResponse` Returns document certificate
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `404` `void` Certificate not found
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  documentCertificateControllerGetDocumentById = (
    id: number,
    params: RequestParams = {},
  ) =>
    this.request<ApiDocumentCertificateResponse, ApiBaseError>({
      path: `/gtw/certificate/documents/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Video Certificates
   * @name VideoCertificateControllerSignVideo
   * @summary Generate signed authenticity certificate
   * @request POST:/gtw/certificate/videos/sign
   * @secure
   * @response `200` `ApiVideoCertificateResponse` Returns signed authenticity certificate with digital signature
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  videoCertificateControllerSignVideo = (
    data: ApiVideoMetadataDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiVideoCertificateResponse, ApiBaseError>({
      path: `/gtw/certificate/videos/sign`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Video Certificates
   * @name VideoCertificateControllerVerifyVideo
   * @summary Verify video certificate authenticity
   * @request POST:/gtw/certificate/videos/verify
   * @secure
   * @response `200` `ApiVideoCertificateVerifyResponse` Returns true if certificate is valid
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Invalid certificate signature
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `404` `void` Certificate not found
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  videoCertificateControllerVerifyVideo = (
    data: ApiVerifyVideoCertificateDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiVideoCertificateVerifyResponse, ApiBaseError>({
      path: `/gtw/certificate/videos/verify`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Video Certificates
   * @name VideoCertificateControllerVerifyVideoFromFile
   * @summary Verify video certificate authenticity from file
   * @request POST:/gtw/certificate/videos/verify/file
   * @secure
   * @response `200` `ApiVideoCertificateVerifyResponse` Returns true if certificate is valid
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Invalid certificate signature
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  videoCertificateControllerVerifyVideoFromFile = (
    params: RequestParams = {},
  ) =>
    this.request<ApiVideoCertificateVerifyResponse, ApiBaseError>({
      path: `/gtw/certificate/videos/verify/file`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Video Certificates
   * @name VideoCertificateControllerGetAllVideosByWillId
   * @summary Get all video certificates by will ID
   * @request GET:/gtw/certificate/videos/wills/{willId}
   * @secure
   * @response `200` `(ApiVideoCertificateResponse)[]` Returns array of video certificates
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  videoCertificateControllerGetAllVideosByWillId = (
    willId: string,
    params: RequestParams = {},
  ) =>
    this.request<ApiVideoCertificateResponse[], ApiBaseError>({
      path: `/gtw/certificate/videos/wills/${willId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Video Certificates
   * @name VideoCertificateControllerGetVideoById
   * @summary Get video certificate by ID
   * @request GET:/gtw/certificate/videos/{id}
   * @secure
   * @response `200` `ApiVideoCertificateResponse` Returns video certificate
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `404` `void` Certificate not found
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  videoCertificateControllerGetVideoById = (
    id: number,
    params: RequestParams = {},
  ) =>
    this.request<ApiVideoCertificateResponse, ApiBaseError>({
      path: `/gtw/certificate/videos/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
